import { getRecoil, setRecoil } from 'recoil-nexus';

import { requestApi } from 'api/Api';

import { getSessionClientId, socketEmit } from 'lib/clients/socket';

import state from 'components/state';

const onAuthReq = async () => {
  let socketSessionTokenState = getRecoil(state.socketSessionTokenState);
  if (!socketSessionTokenState) {
    const resData = await requestApi({
      url: '/api/user/check_token',
      navigate: () => {}
    });
    const { socketSession, token_valid } = resData;
    if (!token_valid) return;
    setRecoil(state.socketSessionTokenState, socketSession);
    socketSessionTokenState = socketSession;
  }
  socketEmit('user-auth', {
    token: socketSessionTokenState,
    sessionClientId: getSessionClientId()
  });
};

export default onAuthReq;
